// extracted by mini-css-extract-plugin
export default {"login":"Login_login__0Yg8z","form":"Login_form__s+DUm","title":"Login_title__thwp8","action":"Login_action__4ALNy","button":"Login_button__K1LGo","link":"Login_link__I6pgp"};